import CustomTextInput from '../../../components/Form/custom-text-input';

const AddStoreForm: React.FC = () => {
  return (
    <>
      <CustomTextInput
        type="text"
        label="Store Name"
        name="name"
        divClass="w-full flex flex-col "
        labelClass="w-full text-left text-gray-600"
        inputClass="w-full my-1 px-4 py-1 rounded-md"
      />
      <CustomTextInput
        type="text"
        label="Email"
        name="email"
        divClass="w-full flex flex-col"
        labelClass="w-full text-left text-gray-600"
        inputClass="w-full my-1 px-4 py-1 rounded-md"
      />
      <CustomTextInput
        type="text"
        label="Phone"
        name="phone"
        divClass="w-full flex flex-col"
        labelClass="w-full text-left text-gray-600"
        inputClass="w-full my-1 px-4 py-1 rounded-md"
      />
      <CustomTextInput
        type="text"
        label="Address"
        name="address"
        divClass="w-full flex flex-col"
        labelClass="w-full text-left text-gray-600"
        inputClass="w-full my-1 px-4 py-1 rounded-md"
      />
    </>
  );
};

export default AddStoreForm;
